import { CONSTANTS } from '../data.js';

// Memoize the maps so they are only created once.
let allItemsMap: Map<string, any> | null = null;
let normalizedRecipesMap: Map<string, any> | null = null;

export const getAllItemsMap = () => {
  if (allItemsMap) {
    return allItemsMap;
  }
  const map = new Map();
  Object.entries(CONSTANTS.ITEMS).forEach(([id, item]) => {
    map.set(id, { ...item, id });
  });
  Object.entries(CONSTANTS.RECIPES).forEach(([id, recipe]) => {
    map.set(recipe.result.id, recipe.result);
  });
  allItemsMap = map;
  return allItemsMap;
};

export const getNormalizedRecipesMap = () => {
  if (normalizedRecipesMap) {
    return normalizedRecipesMap;
  }
  const map = new Map();
  Object.entries(CONSTANTS.RECIPES).forEach(([id, recipe]) => {
    const key = recipe.ingredients.sort().join("_");
    map.set(key, { id, recipe });
  });
  normalizedRecipesMap = map;
  return normalizedRecipesMap;
};

export const createResultToRecipeMap = (discoveredRecipes: string[]) => {
  const map = new Map();
  Object.entries(CONSTANTS.RECIPES).forEach(([id, recipe]) => {
    map.set(recipe.result.id, { 
      ...recipe, 
      id, 
      discovered: discoveredRecipes.includes(id) 
    });
  });
  return map;
};
